import React, { FC } from 'react';
import { Button, Modal } from 'antd';

type ProcedureConfirmationModalProps = {
    open: boolean;
    title: string;
    handleCancel: () => void;
    handleSave: () => void;
}
const ProcedureConfirmationModal: FC<ProcedureConfirmationModalProps> = (props) => {
  
  return (
    <>
      <Modal
        open={props?.open}
        title={props?.title}
        onCancel={props?.handleCancel}
        centered
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <Button onClick={props?.handleCancel}>No</Button>
            <Button onClick={props?.handleSave}>Yes</Button>
          </>
        )}
      >
      </Modal>
    </>
  );
};

export default ProcedureConfirmationModal;